import { Directive, OnInit, ElementRef, Renderer2, HostListener } from "@angular/core";
import { Subscription } from "rxjs";
import { KeyboardService } from "src/app/services/keyboard.service";



@Directive({
  selector: '[appOskInput]'
})
export class OskInputDirective implements OnInit {
  private keySubscription: Subscription;
  private backspaceSubscription: Subscription;
  private enterSubscription: Subscription;
  private measure: HTMLElement;
  private inputValue: string = '';
  private inputType: string = '';

  constructor(private el: ElementRef, private keyboard: KeyboardService, private renderer: Renderer2) { }

  ngOnInit() {
    // TODO I'm sure there's an "Angular way" of doing this
    let thisStyle = window.getComputedStyle(this.el.nativeElement);
    this.measure = document.createElement("span");
    this.measure.style.position = "absolute";
    this.measure.style.right = "100%";
    this.measure.style.font = thisStyle.font;
    document.body.appendChild(this.measure);
    this.keyboard.setkeyboardtype('text');
    // Inicializa inputValue con el valor actual del input
    this.inputValue = this.el.nativeElement.value;
  }

  @HostListener("focus")
  private onFocus() {
    this.keyboard.fireKeyboardRequested(true);
    this.keyboard.updateKeyboardInput(this.inputValue);
    this.subscribeToKeyboardEvents();

  }

  @HostListener("blur")
  private onBlur() {
    this.keyboard.fireKeyboardRequested(false);
    this.unsubscribeFromKeyboardEvents();
  }

  private subscribeToKeyboardEvents() {
    this.keySubscription = this.keyboard.keyPressed.subscribe(key =>
      this.onKey(key)
    );
    this.backspaceSubscription = this.keyboard.backspacePressed.subscribe(_ =>
      this.onBackspace()
    );
    this.enterSubscription = this.keyboard.enterPressed.subscribe(_ =>
      this.onEnter()
    );
  }

  private unsubscribeFromKeyboardEvents() {
    this.keySubscription.unsubscribe();
    this.backspaceSubscription.unsubscribe();
    this.enterSubscription.unsubscribe();
  }

  private onKey(key: string) {
    // TODO Refactor this into a single method with the code in onBackspace
    let element = this.el.nativeElement,
      start = element.selectionStart,
      end = element.selectionEnd;


    // Actualiza el valor del input utilizando Renderer2
    const newValue = element.value.substr(0, start) + key + element.value.substr(end);
    this.renderer.setProperty(element, 'value', newValue);

    // Dispara un evento de cambio para notificar a Angular
    const event = new Event('input', { bubbles: true });
    element.dispatchEvent(event);

    // Actualiza la variable inputValue con el nuevo valor del input
    this.inputValue = newValue;
    this.updateScrollPosition();
    this.keyboard.updateKeyboardInput(newValue);
  }

  private onBackspace() {
    let element = this.el.nativeElement,
      start = element.selectionStart,
      end = element.selectionEnd;

    if (start == 0) {
      return;
    }

    if (start == end) {
      start--;
    }

    // Actualiza el valor del input utilizando Renderer2
    const newValue = element.value.substr(0, start) + element.value.substr(end);
    this.renderer.setProperty(element, 'value', newValue);

    // Dispara un evento de cambio para notificar a Angular
    const event = new Event('input', { bubbles: true });
    element.dispatchEvent(event);

    // Actualiza la variable inputValue con el nuevo valor del input
    this.inputValue = newValue;
    this.updateScrollPosition();
    this.keyboard.updateKeyboardInput(newValue);
  }

  private updateScrollPosition() {
    let element = this.el.nativeElement;
    element.scrollLeft = this.measure.offsetWidth - (element.clientWidth - 10);
  }

  private onEnter() {
    this.onBlur();

  }
}
